import { render, staticRenderFns } from "./printHead.vue?vue&type=template&id=22547a1a&"
import script from "./printHead.vue?vue&type=script&lang=js&"
export * from "./printHead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports